import { createTheme } from '@material-ui/core/styles';
import darkTheme from 'config/themes/darkTheme';

const lightTheme = createTheme({
  ...darkTheme,
  palette: {
    ...darkTheme.palette,
    customColors: {
      main: '#979797',
      orange: '#F9C106',
      lightGray: '#EBEBEB',
      gray: '#ABAFB5',
      green: '#59BA49',
    },
    background: {
      default: '#ffffff',
      paper: '#F8F8F8',
    },
    text: {
      primary: '#000000',
      secondary: '#333333',
    },
  },
  overrides: {
    ...darkTheme.overrides,
    MuiPaper: {
      root: { backgroundColor: '#ffffff' },
    },
    MuiContainer: {
      fixed: {
        '@media(min-width: 1920px)': {
          maxWidth: 1280,
        },
      },
    },
    MuiDivider: {
      root: {
        backgroundColor: '#eaeaea',
      },
    },
  },
});
export default lightTheme;
